import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import "./PracticeSummaryComponent.css";
import { fetchPracticeSummaryRequest , fetchExamInstructionRequest} from "../../../../redux/exam/examSlice";
import images from "../../../../utilities/images/images";

const PracticeSummaryComponent = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const {
    testDetails,
    practiceSummary,
    loading,
    selectedSetId,
    selectedType, 
  } = useSelector((state) => state.examSlice);
const source = testDetails?.source;
 useEffect(() => {
  if (testDetails?.practiceMode !== "practice") return;

  // Build params object — only include keys that have real values
  const params = {
    paper_type: testDetails.paperType,          
     paper_id: testDetails.paperId,
    gamification_status: testDetails?.gamificationOn ? 1 : 0,
  };
if (testDetails?.setId) {
  params.set_id = testDetails.setId;
}

  dispatch(fetchPracticeSummaryRequest(params));
}, [
  dispatch,
  testDetails?.practiceMode,
  testDetails?.paperType,
  testDetails?.paperId,
  testDetails?.gamificationOn,
  selectedSetId,
  selectedType,
]);

  if (loading) {
    return (
      <div className="ps-wrapper">
        <p style={{ textAlign: "center" }}>Loading practice summary…</p>
      </div>
    );
  }

  if (!practiceSummary?.data) {
    return (
      <div className="ps-wrapper">
        <p style={{ textAlign: "center" }}>
          Practice summary not available.
        </p>
        <div style={{ textAlign: "center", marginTop: 16 }}>
          <button className="btn-dark" onClick={() => history.push("/tests")}>
            Back To Tests
          </button>
        </div>
      </div>
    );
  }

  const {
    test_name,
    attempted,
    time_spent,
    accuracy,
    show_viewsolution,
    hide_reattempt,
    question_breakdown,
    streak_count,
  } = practiceSummary.data;
  const hasStreak = Number(streak_count?.count) > 0;
  console.log("DEBUG STATE:", {
  practiceMode: testDetails?.practiceMode,
  paperType: testDetails?.paperType,
  paperId: testDetails?.paperId,
  gamificationOn: testDetails?.gamificationOn,
  selectedType,
  selectedSetId,
});

  return (
    <div className="ps-wrapper">
      {/* HEADER */}
      <div className="ps-header">
        <span className="ps-back" onClick={() => history.goBack()}>
          <img src={images.new_backarrow} alt="back arrow" />
        </span>
        <h2 className="ps-heading">Practice Summary</h2>
      </div>

      <div className="ps-alert">• This summary will not be saved</div>

      {/* STREAK */}
    {hasStreak&&(<div className="ps-streak">
        <div className="ps-streak-content">
          <div className="ps-streak-top">
            <span className="ps-fire">
              <img
                src={images.streakfire_icon}
                alt="fire"
                className="ps-fire-icon"
              />
            </span>
            <h1>{streak_count?.count || "-"}</h1>
            <span className="ps-questions">Questions</span>
          </div>

          <p className="ps-streak-label">
            {streak_count?.title || "No streak yet"}
          </p>

          <div className="ps-streak-badge">
            {streak_count?.message ||
              "Answer questions correctly in a row to build a streak!"}
          </div>
        </div>

        <div className="ps-streak-emoji">
          <img
            src={images.bird_icon}
            alt="streak"
            className="ps-streak-icon"
          />
        </div>
      </div>)}

      <h3 className="ps-title">{test_name}</h3>

      {/* METRICS */}
      <div className="ps-metrics-wrapper">
        <div className="ps-metrics-box">
          <h4 className="ps-section-title">Performance Metrics</h4>

          <div className="ps-performance-grid">
            <div className="ps-card ps-accuracy">
              <div className="ps-circle">
                <span className="ps-percent">{accuracy}%</span>
                <span className="ps-label">Accuracy</span>
              </div>
            </div>

            <div className="ps-card">
              <h4>{attempted}</h4>
              <p>Attempted Q’s</p>
            </div>

            <div className="ps-card">
              <h4>{time_spent}</h4>
              <p>Time Spent</p>
            </div>
          </div>
        </div>

        <div className="ps-metrics-box">
          <h4 className="ps-section-title">Question Breakdown</h4>

          <div className="ps-breakdown-grid">
            {question_breakdown?.map((item) => (
              <div
                key={item.id}
                className="ps-card"
                style={{
                  background: item.bg_color,
                  border: `1px solid ${item.border_color}`,
                  color: item.text_color,
                }}
              >
                <h4 style={{ color: item.value_text_color }}>
                  {item.value}
                </h4>
                <p style={{ color: item.value_text_color }}>
                  {item.label}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ACTIONS */}
      <div className="ps-actions">
        {show_viewsolution && (
          <button className="btn-outline"
         onClick={() =>
  history.push("/practice-view-solution", {
    paperType: testDetails?.paperType,
    paperId: testDetails?.paperId,
    setId: testDetails?.setId,
  })
}
          >View Solution</button>
        )}

        <div>
          {/* {!hide_reattempt && <button className="btn-light">Reattempt</button>} */}
          {!hide_reattempt && (
           <button
           className="btn-light"
           onClick={() => {
           dispatch(fetchExamInstructionRequest(testDetails));
           history.push("/TestInstruction");
            }}
             >
            Reattempt
            </button>
            )}
          <button
            className="btn-dark"
            // onClick={() =>
            //   history.push("/practice/paper-listing?type=Year%20Wise")
            // }
            onClick={() => {
    if (source === "topicwise") {
      history.push("/practice/topic-wise/pyqset");
    } else if (source === "yearwise") {
      history.push("/practice/paper-listing?type=Year Wise");
    } else {
      history.push("/practice/paper-listing");
    }
  }}
          >
            Back To Tests
          </button>
        </div>
      </div>
    </div>
  );
};

export default PracticeSummaryComponent;
